// src/pages/storePages/StoreCategoryPage.js
import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import {
  storeGetCategoryBySlug,
  storeGetCategoriesByParentSlug,
} from "../../storeAPIs/StoreCategoriesApis";
import { storeGetProductsByCategory } from "../../storeAPIs/StoreProductsAPIs";

export default function StoreCategoryPage() {
  const { slug } = useParams();
  const [category, setCategory] = useState(null);
  const [children, setChildren] = useState([]);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(null);

    Promise.all([
      storeGetCategoryBySlug(slug),
      storeGetCategoriesByParentSlug(slug),
      storeGetProductsByCategory(slug),
    ])
      .then(([catRes, childRes, prodRes]) => {
        if (cancelled) return;
        setCategory(catRes.data);
        setChildren(childRes.data?.results ?? childRes.data ?? []);
        setProducts(prodRes.data?.results ?? prodRes.data ?? []);
      })
      .catch((err) => {
        if (!cancelled) setError(err.message || "Failed to load category.");
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [slug]);

  if (loading) return <p>Loading…</p>;
  if (error) return <p style={{ color: "red" }}>{error}</p>;
  if (!category) return <p>Category not found.</p>;

  return (
    <div className="store-category-page">
      <h1>{category.name}</h1>

      {children.length > 0 && (
        <section>
          <h2>Subcategories</h2>
          <ul>
            {children.map((child) => (
              <li key={child.id}>
                <Link to={`/store/category/${child.slug}`}>{child.name}</Link>
              </li>
            ))}
          </ul>
        </section>
      )}

      {products.length > 0 && (
        <section>
          <h2>Products</h2>
          <ul>
            {products.map((product) => (
              <li key={product.id}>
                <Link to={`/store/product/${product.slug}`}>
                  {product.name}
                </Link>
                {" — "}
                {product.price}
              </li>
            ))}
          </ul>
        </section>
      )}

      {children.length === 0 && products.length === 0 && (
        <p>Nothing here yet.</p>
      )}
    </div>
  );
}